// lib/date/convert.ts
var toHHMMSS = (totalSecsInput) => {
  const totalSecs = Math.round(totalSecsInput);
  const hours = Math.floor(totalSecs / 3600);
  const minutes = Math.floor(totalSecs / 60) % 60;
  const seconds = totalSecs % 60;
  return [hours, minutes, seconds].map((v) => v < 10 ? "0" + v : v).filter((v, i) => v !== "00" || i > 0).join(":");
};
var toMMDDHHMM = (date) => {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });
};
var toMMDDHHMMSS = (date) => {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  });
};
var toYYYYMMDD = (date) => {
  if (!isValidDate(date)) {
    return "";
  }
  return date.toISOString().split("T")[0];
};
var isValidDate = (date) => !isNaN(date.getFullYear());
var fromYYYYMMDD = (date) => {
  const parts = date.split("-");
  return new Date(
    parseInt(parts[0]),
    parseInt(parts[1]) - 1,
    parseInt(parts[2]),
    0,
    0,
    0,
    0
  );
};
var addHours = (date, hours) => {
  const result = new Date(date);
  result.setHours(result.getHours() + hours);
  return result;
};
var isToday = (date) => {
  const today = /* @__PURE__ */ new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};
var toMonth = (date) => {
  const userLocale = navigator.language || "en-US";
  return date.toLocaleDateString(userLocale, {
    month: "long"
  });
};
var timeAgo = (date, now = /* @__PURE__ */ new Date()) => {
  const diffMs = now.getTime() - date.getTime();
  if (diffMs < 0) return "just now";
  const diffSecs = Math.floor(diffMs / 1e3);
  if (diffSecs < 60) return `${diffSecs} second${diffSecs === 1 ? "" : "s"} ago`;
  const diffMins = Math.floor(diffSecs / 60);
  if (diffMins < 60) return `${diffMins} minute${diffMins === 1 ? "" : "s"} ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24)
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12)
    return `${diffMonths} month${diffMonths === 1 ? "" : "s"} ago`;
  const diffYears = Math.floor(diffMonths / 12);
  return `${diffYears} year${diffYears === 1 ? "" : "s"} ago`;
};
var intToMonth = (oneIndexMonth) => {
  if (oneIndexMonth < 1 || oneIndexMonth > 12) return "Invalid Month";
  const userLocale = typeof window !== "undefined" ? navigator.language : "en-US";
  const formatter = new Intl.DateTimeFormat(userLocale, { month: "long" });
  return formatter.format(new Date(2e3, oneIndexMonth - 1, 1));
};
export {
  addHours,
  fromYYYYMMDD,
  intToMonth,
  isToday,
  isValidDate,
  timeAgo,
  toHHMMSS,
  toMMDDHHMM,
  toMMDDHHMMSS,
  toMonth,
  toYYYYMMDD
};
